<div class="max-h-screen">
	<h1 class="font-medium text-gray-950 text-3xl mb-6">Business Settings</h1>

	<div class="flex flex-col gap-6 pb-10">
		<app-general-settings />

		<app-ltt-settings
			[sectionTitle]="CollapsableBusinessSettingsSection.LTT_AND_MLTT"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>

		<app-title-search-settings
			[sectionTitle]="CollapsableBusinessSettingsSection.TITLE_SEARCH"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>

		<app-title-insurance-general
			[sectionTitle]="CollapsableBusinessSettingsSection.TITLE_INSURANCE"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>

		<app-instrument-registration-settings
			[sectionTitle]="
				CollapsableBusinessSettingsSection.INSTRUMENT_REGISTRATION
			"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>

		<app-idv-general
			[sectionTitle]="CollapsableBusinessSettingsSection.ID_VERIFICATION"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>

		@if (eSigningFlagSignal()) {
			<app-e-signing-general
				id="E_SIGNING"
				[sectionTitle]="CollapsableBusinessSettingsSection.E_SIGNING"
				[sectionCollapsedStates]="sectionCollapsedStates()"
				(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
			/>
		}

		<app-assyst-fee
			[sectionTitle]="CollapsableBusinessSettingsSection.ASSYST_FEES"
			[sectionCollapsedStates]="sectionCollapsedStates()"
			(sectionCollapsedChanged)="handleSectionCollapsedChange($event)"
		/>
	</div>
</div>
